<template>
    <div />
</template>

<script>
import Kernel from "@oilstone/kernel";
import Navigation from "../../../services/navigation";

export default {
    mounted() {
        const repository = Kernel.resolve("resourceRegistry").find("shortcuts").repository;
        const path = Kernel.resolve("router").currentRoute.value.fullPath.substring(1);

        repository
            .baseQuery()
            .where("path", path)
            .first()
            .then(shortcut => {
                Navigation.push({ path: shortcut.redirectTo });
            })
            .catch(() => {
                Navigation.push({ name: "404", params: { language: "en" } });
            });
    },
};
</script>
